import { DateValueType } from 'react-tailwindcss-datepicker';
import { LicenseStatus } from '../types/data';

export const getLicenseStatusId = (status: LicenseStatus, statusFilter: any[]): number => {
  const statusItem = statusFilter?.find((item) => item.Title === status);
  return statusItem?.ID || 1; 
};

//! обновления статуса карточки
export const determineLicenseStatus = (startDate: Date | null, endDate: Date | null, isArchived: boolean): LicenseStatus => {
  if (isArchived) {
    return 'В архиве';
  }

  const currentDate = new Date();

  const nextDay = new Date(currentDate);
  nextDay.setDate(nextDay.getDate() - 1);

  if (!startDate) {
    return 'В процессе';
  }
  if (startDate > currentDate) {
    return 'В процессе';
  }
  if (startDate <= currentDate && (!endDate || endDate > nextDay)) {
    return 'Действующий';
  }
  if (endDate && endDate <= nextDay) {
    return 'Просрочен';
  }
  return 'В процессе';
};

export const getFormattedDates = (watchStartDate: any, watchEndDate: any, initialValues: any): { startDate: Date | null; endDate: Date | null } => {
  let startDate = null;
  let endDate = null;

  if (watchStartDate?.startDate || watchEndDate?.startDate) {
    startDate = watchStartDate?.startDate ? new Date(watchStartDate.startDate) : null;
    endDate = watchEndDate?.startDate ? new Date(watchEndDate.startDate) : null;
  } else if (initialValues) {
    startDate = initialValues.startDateDocument?.startDate ? new Date(initialValues.startDateDocument.startDate) : null;
    endDate = initialValues.expirationDateDocument?.startDate ? new Date(initialValues.expirationDateDocument.startDate) : null;
  }

  return { startDate, endDate };
};

//! обвление срока действия карточки
export const updateValidityPeriod = (watchStartDate: any, watchEndDate: any, calculateValidityPeriod: any) => {
  if (!watchStartDate && !watchEndDate) {
    return '-';
  }
  if (watchStartDate?.startDate && !watchEndDate?.startDate) {
    return 'Бессрочный';
  }
  if (watchStartDate || watchEndDate) {
    const validityPeriod = calculateValidityPeriod(watchStartDate, watchEndDate);
    if (validityPeriod !== null) {
      return String(validityPeriod);
    }
  }
  return '-';
};

//! автосохранение пустой записи при открытии модалки
export const formatEmptyLicenseBody = (documentStatus: string, actionStatus: string, defaultResponsible: any, licenseStatusFilter: any[], actionStatusFilter: any[]) => {
  
  const licenseStatusId = getLicenseStatusId(documentStatus as LicenseStatus, licenseStatusFilter);
  
  return {
    // Title: `Licenses null`,
    GOSLocation: null,
    TypeActivity: null,
    DocumentType: null,
    NameDocument: '-',
    DocumentNumber: '-',
    StartDateDocument: null,
    ExpirationDateDocument: null,
    ValidityPeriodDocument: null,
    DetailedDescription: '-',
    GovernmentAgency: null,
    NamesStateBody: '-',
    // Responsible: defaultResponsible.email,
    ResponsibleEmail: defaultResponsible.email,
    // InterestedParties: [],
    InterestedPartiesEmails: [],
    DateUpdate: null,
    Comment: '-',
    Products: '-',
    ND: '-',
    Code_TN_VED: '-',
    Code_OKPD: '-',
    CodeTypeAlcoholicBeverages: '-',
    CertificationBody: '-',
    GTD_samples: '-',
    TransferDeclarationBroker: '-',
    LicenseStatus: licenseStatusId, 
    IsArchived: false,
  };
};

//! Для расчета срока действия
export const calculateValidityPeriod = (startDate: DateValueType, endDate: DateValueType): number | null => {
  if (!startDate?.startDate || !endDate?.startDate) {
    return null;
  }
  const start = new Date(startDate.startDate);
  const end = new Date(endDate.startDate);
  const diffInYears = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24 * 365);
  return Math.round(diffInYears * 10) / 10;
};
